import {
  isValidEmail,
  isValidMobile,
  isValidName,
  isValidPassword,
  getNotifMsg,
} from 'utils';
const validateSignup = (values, locale = 'fa') => {
  const { firstName, lastName, mobile, email, password } = values;
  const errors = {};
  if (!firstName) {
    errors.firstName = getNotifMsg('SIGNUP_ENTER_NAME', locale);
  } else if (firstName.length < 2) {
    errors.firstName = getNotifMsg('SIGNUP_NAME_LENGTH', locale);
  } else if (!isValidName(firstName)) {
    errors.firstName = getNotifMsg('SIGNUP_NAME_INVALID', locale);
  }
  if (!lastName) {
    errors.lastName = getNotifMsg('ENTER_LASTNAME', locale);
  } else if (lastName.length < 2) {
    errors.lastName = getNotifMsg('SIGNUP_LASTNAME_LENGTH', locale);
  } else if (!isValidName(firstName)) {
    errors.firstName = getNotifMsg('SIGNUP_LASTNAME_INVALID', locale);
  }
  if (!email) {
    errors.email = getNotifMsg('ENTER_EMAIL', locale);
  } else if (!isValidEmail(email)) {
    errors.email = getNotifMsg('EMAIL_INVALID', locale);
  }
  if (!mobile) {
    errors.mobile = getNotifMsg('ENTER_MOBILE', locale);
  } else if (!isValidMobile(mobile)) {
    errors.mobile = getNotifMsg('INVALID_MOBILE', locale);
  }
  if (!password) {
    errors.password = getNotifMsg('ENTER_PASSWORD', locale);
  } else if (password.length <= 8) {
    errors.password = getNotifMsg('PASSWORD_LENGTH_INVALID', locale);
  } else if (!isValidPassword(password)) {
    errors.password = getNotifMsg('PASSWORD_INVALID_CHARS', locale);
  }
  return errors;
};

export default validateSignup;
